import { TQueryParams } from '../interfaces/common'
import { getQueryParam } from './getQueryParam'

export const anyToNumber = (any: any): number | undefined => {
  if (!any) return undefined
  const parsedInt = parseInt(any, 10)

  if (Number.isNaN(parsedInt)) return undefined

  return parseInt(any, 10) ?? undefined
}

export const getAppIdFromReglink = (reglink: string | undefined): number | undefined => {
  if (!reglink) return undefined
  const regLinkSearchParams = reglink.split('?')[1]
  const regLinkSearchParamsParsed = new URLSearchParams(regLinkSearchParams)
  const regLinkAppidString = regLinkSearchParamsParsed.get('appid') ?? regLinkSearchParamsParsed.get('appId')

  return anyToNumber(regLinkAppidString)
}

export const getAppId = (query: TQueryParams): number | undefined => {
  const reglink = getQueryParam(query, 'reglink')
  const appid = getQueryParam(query, 'appid')
  const appId = getQueryParam(query, 'appId')

  if (reglink) {
    const appId = getAppIdFromReglink(reglink)

    if (appId) return appId
  }

  if (appid || appId) {
    const total = anyToNumber(appid || appId)

    if (total) return total
  }

  return undefined
}
